import { ethers } from 'ethers'
import { simpleRpcProvider } from 'utils/providers'
import { multiPoolConfig } from 'config/constants'
import { Address } from 'config/constants/types'

// Addresses
import {
  getAddress,
  getDmdAddress,
  getDmdvaultAddress,
  getMasterChefAddress,
  getMulticallAddress,
  getNftKeyAddress,
  getNftMultiTransferAddress,
  getNftLaunchpadFactoryAddress,
  getPresaleAddress,
  getWant,
  getZapAddress,
  getLotteryAddress,
  getNftLaunchpadFactoryV2Address,
} from 'utils/addressHelpers'

// ABI
import bep20Abi from 'config/abi/erc20.json'
import lpTokenAbi from 'config/abi/lpToken.json'
import dmdAbi from 'config/abi/dmd.json'
import masterChef from 'config/abi/masterchef.json'
import nftLaunchpadFactory from 'config/abi/nftLaunchpadFactory.json'
import nftLaunchpadFactoryV2 from 'config/abi/nftLaunchpadFactoryV2.json'
import nftMultiTransferAbi from 'config/abi/nftMultiTransfer.json'
import presaleAbi from 'config/abi/presale.json'
import multiPoolAbi from 'config/abi/multiPool.json'
import MultiCallAbi from 'config/abi/Multicall.json'
import Strategy from 'config/abi/strategy.json'
import Darkvaultabi from 'config/abi/darkvault.json'
import NftKeyAbi from 'config/abi/nftkey.json'
import Want from 'config/abi/want.json'
import Dmdvault from 'config/abi/dmdvault.json'
import NftAbi from 'config/abi/nft.json'
import NftV2Abi from 'config/abi/nftV2.json'
import NftPoolAbi from 'config/abi/nftPool.json'
import NftPoolWithMCAbi from 'config/abi/nftPoolWithMC.json'
import ZapAbi from 'config/abi/zap.json'
import LotteryAbi from 'config/abi/lottery.json'
import { Series } from 'state/types'

const getContract = (abi: any, address: string, signer?: ethers.Signer | ethers.providers.Provider) => {
  const signerOrProvider = signer ?? simpleRpcProvider
  return new ethers.Contract(address, abi, signerOrProvider)
}

export const getPresaleContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(presaleAbi, getPresaleAddress(), signer)
}
export const getBep20Contract = (address: string, signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(bep20Abi, address, signer)
}
export const getLpContract = (address: string, signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(lpTokenAbi, address, signer)
}
export const getMultiPoolContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(multiPoolAbi, getAddress(multiPoolConfig.contractAddress), signer)
}
export const getNftMultiTransferContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(nftMultiTransferAbi, getNftMultiTransferAddress(), signer)
}
export const getDmdContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(dmdAbi, getDmdAddress(), signer)
}
export const getMasterchefContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(masterChef, getMasterChefAddress(), signer)
}
export const getNftLaunchpadFactoryV2Contract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(nftLaunchpadFactoryV2, getNftLaunchpadFactoryV2Address(), signer)
}
export const getNftLaunchpadFactoryContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(nftLaunchpadFactory, getNftLaunchpadFactoryAddress(), signer)
}
export const getMulticallContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(MultiCallAbi, getMulticallAddress(), signer)
}

export const getNftKeyContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(NftKeyAbi, getNftKeyAddress(), signer)
}
export const getStrategyContract = (address: Address, signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(Strategy, getAddress(address), signer)
}
export const getDarkVaultContract = (address: Address, signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(Darkvaultabi, getAddress(address), signer)
}
export const want = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(Want, getWant(), signer)
}
export const getDmdVaultContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(Dmdvault, getDmdvaultAddress(), signer)
}
export const getNftContract = (address: Address, signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(NftAbi, getAddress(address), signer)
}
export const getNftV2Contract = (address: Address, signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(NftV2Abi, getAddress(address), signer)
}

export const getNftPoolContract = (series: Series, signer?: ethers.Signer | ethers.providers.Provider) => {
  if (series.pool) {
    return getContract(series.withoutMC ? NftPoolAbi : NftPoolWithMCAbi, getAddress(series.pool), signer)
  }
  return null
}
export const getZapContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(ZapAbi, getZapAddress(), signer)
}
export const getLotteryContract = (signer?: ethers.Signer | ethers.providers.Provider) => {
  return getContract(LotteryAbi, getLotteryAddress(), signer)
}
